import React from "react";
import { Stack, TextInput, Text } from "@mantine/core";
import { LookupFieldOptions } from "./fieldOptionsTypes";
import { LookupDictionarySelector } from "@/components/features/LookupDictionaries/LookupDictionarySelector";

export interface LookupFieldOptionsEditorProps {
  value: LookupFieldOptions;
  onChange: (options: LookupFieldOptions) => void;
}

export const LookupFieldOptionsEditor: React.FC<
  LookupFieldOptionsEditorProps
> = ({ value, onChange }) => {
  const handleChange = (field: keyof LookupFieldOptions, fieldValue: any) => {
    onChange({
      ...value,
      [field]: fieldValue === "" ? undefined : fieldValue,
    });
  };

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed">
        Configure lookup dictionary validation. Values will be validated against
        the specified dictionary.
      </Text>

      <LookupDictionarySelector
        label="Dictionary"
        placeholder="Select a lookup dictionary"
        description="Select the lookup dictionary to validate against"
        value={value.lookupDictionaryId ?? null}
        onChange={(lookupDictionaryId) =>
          handleChange("lookupDictionaryId", lookupDictionaryId)
        }
        required
        size="sm"
      />

      <TextInput
        label="Filter 1"
        placeholder="e.g., US or {{country}}"
        description="Static value or reference another field using {{fieldName}} syntax"
        value={value.filter1 ?? ""}
        onChange={(e) => handleChange("filter1", e.target.value)}
        size="sm"
      />

      <TextInput
        label="Filter 2"
        placeholder="e.g., CA or {{state}}"
        description="Static value or reference another field using {{fieldName}} syntax"
        value={value.filter2 ?? ""}
        onChange={(e) => handleChange("filter2", e.target.value)}
        size="sm"
      />
    </Stack>
  );
};
